export default "__VITE_ASSET__D$_aPf$G__"